import type Pageable from 'models/Pageable';
import type { WaitingInvoiceVO, WaitingInvoiceVOModel } from 'models/vo/WaitingInvoiceVO';
import { formattingToWaitingInvoiceVOModel } from 'models/vo/WaitingInvoiceVO';
import http from 'utils/http';
import API_SY from 'utils/http/api/system';

export async function requestSystemWaitingInvoiceList(
  pageNumber: number,
  rowCount: number,
  waitingInvoiceApprovalPhaseId: number,
): Promise<Pageable<WaitingInvoiceVOModel[]>> {
  const response = await http.get<Pageable<WaitingInvoiceVO[]>>({
    url: API_SY.WAITING_INVOICES.WAITING_INVOICE_LIST,
    data: {
      pageNumber,
      rowCount,
      waitingInvoiceApprovalPhaseId: waitingInvoiceApprovalPhaseId,
    },
  });

  const waitingInvoiceData = response.content.map(waitingInvoice => formattingToWaitingInvoiceVOModel(waitingInvoice));

  return {
    ...response,
    content: waitingInvoiceData,
  };
}
